export default "__VITE_ASSET__w1UuJGGi__"